import React, { useState, useEffect } from 'react';
import { func, bool } from 'prop-types';
import scrollToTop from '@magalu/stereo-ui-utils/scrollToTop';
import { BackToTopIcon } from './backToTop.styles';

function BackToTop({
  onClick,
  show
}) {
  const [visible, setVisibility] = useState(show);
  const viewHeight = window && window.innerHeight;

  const scroll = () => {
    scrollToTop();
    onClick();
  };

  const checkButtonVisibility = () => {
    const pageOffset = window.pageYOffset;

    if (!visible && pageOffset > viewHeight) {
      setVisibility(true);
    } else if (visible && pageOffset <= viewHeight) {
      setVisibility(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', checkButtonVisibility);
    return () => {
      window.removeEventListener('scroll', checkButtonVisibility);
    };
  }, [visible]);
  return visible ? /*#__PURE__*/React.createElement(BackToTopIcon, {
    "data-testid": "back-to-top",
    onClick: scroll
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
}

BackToTop.defaultProps = {
  onClick: () => {},
  show: false
};
process.env.NODE_ENV !== "production" ? BackToTop.propTypes = {
  onClick: func,
  show: bool
} : void 0;
BackToTop.displayName = 'BackToTop';
export default BackToTop;